var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLlunaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 16,
    viewBox: "0 0 78 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_1167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8516 2.20618H20.3341V14.5178H27.561V13.1361H21.8516V2.20618Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5289 2.20618H30.0145V14.5178H37.2383V13.1361H31.5289V2.20618Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7677 8.8686C47.7677 10.2408 47.4287 11.3045 46.757 12.0346C46.0595 12.7266 45.1217 13.1142 44.1449 13.1142C43.1681 13.1142 42.2303 12.7266 41.5327 12.0346C40.8641 11.3139 40.5252 10.2848 40.5252 8.97871V2.12744H39.0015V9.02594C39.0015 10.7317 39.4835 12.0975 40.435 13.092C41.4338 14.0588 42.7635 14.5968 44.1456 14.5933C45.5276 14.5898 46.8546 14.045 47.8485 13.0732C48.8001 12.0692 49.2821 10.6373 49.2821 8.81509V2.12744H47.7677V8.8686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0379 11.8868L53.7352 2.20618H52.5255V14.5178H54.0399V4.83403L62.3615 14.5178H63.5525V2.20618H62.0379V11.8868Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3776 2.17456H71.4852L65.8657 14.5711H67.4892L69.3082 10.5333H74.5546L76.38 14.5711H78L72.3776 2.17456ZM73.9323 9.14862H69.9305L71.927 4.72059L73.9323 9.14862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7546 8.00023C15.7546 6.40698 15.2942 4.84948 14.4316 3.52474C13.569 2.2 12.343 1.16749 10.9085 0.557781C9.47415 -0.0519302 7.8957 -0.211458 6.37289 0.0993704C4.85012 0.410199 3.45135 1.17742 2.35348 2.30402C1.2556 3.43062 0.507945 4.866 0.205043 6.42861C-0.09786 7.99128 0.057601 9.61101 0.651762 11.083C1.24593 12.555 2.25211 13.813 3.54307 14.6982C4.83403 15.5834 6.35176 16.0558 7.90443 16.0558C8.93543 16.0562 9.95641 15.8482 10.9091 15.4435C11.8616 15.0388 12.7272 14.4454 13.4563 13.6974C14.1853 12.9492 14.7635 12.061 15.1579 11.0835C15.5523 10.1059 15.755 9.05818 15.7546 8.00023ZM1.82065 8.00023C1.82065 8.00023 3.29064 11.0963 7.90443 11.0963C12.5182 11.0963 13.9882 8.00023 13.9882 8.00023C13.9882 9.65593 13.3472 11.2438 12.2063 12.4146C11.0654 13.5854 9.51792 14.2431 7.90443 14.2431C6.29088 14.2431 4.74347 13.5854 3.60254 12.4146C2.46162 11.2438 1.82065 9.65593 1.82065 8.00023Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_1167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlunaLogo);
export default __webpack_public_path__ + "static/media/LlunaLogo.9b0ff3be91dc26a7f825e386dc78c7fd.svg";
export { ForwardRef as ReactComponent };